import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a01f0bfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "synopsis-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "cr1" }, "关于", -1))
const _hoisted_3 = { class: "synopsis" }
const _hoisted_4 = { class: "image-slot" }
const _hoisted_5 = { class: "introduce" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "cr8" }, "邵帅", -1))
const _hoisted_7 = { class: "fz" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 前端开发工程师，2019年毕业于'河北软件职业技术学院'，专业'计算机信息管理'，2018.7-至今从事前端开发工作。 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("了解更多>>")
const _hoisted_10 = { class: "survey" }
const _hoisted_11 = { class: "cr3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cr3 fz" }, "博文", -1))
const _hoisted_13 = { class: "cr3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cr3 fz" }, "阅读", -1))
const _hoisted_15 = { class: "cr3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cr3 fz" }, "评论", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "contact" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-weixin cr5" }),
    /*#__PURE__*/_createElementVNode("span", { class: "fz cr2" }, "微信"),
    /*#__PURE__*/_createElementVNode("span", { class: "fz cr3" }, "kaixin-ss520")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-QQ cr4" }),
    /*#__PURE__*/_createElementVNode("span", { class: "fz cr2" }, "QQ"),
    /*#__PURE__*/_createElementVNode("span", { class: "fz cr3" }, "1136627300")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "hover" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_image, {
            src: "http://api.mrshao520.cn/public/img/headerImg/614d76c7c0289c0ae45079fc.png",
            class: "page-note-l"
          }, {
            error: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_icon, { size: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Picture)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_router_link, {
                to: `about`,
                class: "cr6"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(_component_el_divider, { "border-style": "dashed" }),
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", null, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.article), 1),
            _hoisted_12
          ]),
          _createVNode(_component_el_divider, { direction: "vertical" }),
          _createElementVNode("li", null, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.readNum), 1),
            _hoisted_14
          ]),
          _createVNode(_component_el_divider, { direction: "vertical" }),
          _createElementVNode("li", null, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.discuss), 1),
            _hoisted_16
          ])
        ]),
        _createVNode(_component_el_divider, { "border-style": "dashed" }),
        _hoisted_17
      ]),
      _: 1
    })
  ]))
}